import axios from 'axios';
import localStorage from '../../../../utils/localStorage';
import { message } from 'antd';

export async function getModuleList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/rubusMaster/modules/get?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };

  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function getModuleListbyId(idValue) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/rubusMaster/modules/get?SiteId=${siteId}&Id=${idValue}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function canEditModule(moduleCode) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/rubusMaster/hierarchy/checkModuleStatus?SiteId=${siteId}&Code=${moduleCode}`,
    headers: {
      Authorization: Authorization
    }
  };

  return axios(header)
    .then((response) => {
      return response.data.flag;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function getDropdownData(selectedType) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/rubusMaster/assetTypes/get?SiteId=${siteId}&SelectedType=${selectedType}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function createHierarchy(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/rubusMaster/hierarchy/create?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: data
  };
  return axios(header)
    .then((response) => {
      console.log("tttttt create res",response);
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function editHierarchy(data) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'PATCH',
    url: `/api/rubusMaster/hierarchy/update?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: data
  };

  try {
    const response = await axios(header);
    return response.data;
  } catch (err) {
    if (err.response && err.response.data) {
      message.error(`Error: ${err.response.data.message || 'Unknown error'}`);
      console.error('Full server error:', err.response.data);
      throw err.response.data;
    } else {
      message.error(`Network Error: ${err.message}`);
      console.error('Error:', err);
    }
    throw err;
  }
}

export async function EditDatabyId(id, moduleCode) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/rubusMaster/hierarchy/getById?SiteId=${siteId}&Id=${id}&ModuleCode=${moduleCode}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function getHierarchy(moduleName) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/rubusMaster/hierarchy/get?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: moduleName
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function deleteHierarchy(id) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'DELETE',
    url: `/api/rubusMaster/hierarchy/delete?SiteId=${siteId}&Id=${id}`,
    headers: {
      Authorization: Authorization
    }
  };
  try {
    const response = await axios(header);
    message.success('Hierarchy deleted successfully');
    return response.data;
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data.message || 'Deletion failed';

      if (errorMessage === 'Asset Types has assets') {
        message.error('Cannot delete: Asset type has existing assets');
      } else {
        message.error(errorMessage);
      }
    } else {
      message.error('An unexpected error occurred');
    }
    throw error;
  }
}

export async function getTreeDataCall(moduleName) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/rubusMaster/hierarchy/get?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      Code: moduleName,
      LevelType: 'Module'
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function getParamsData(Id) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/rubusMaster/hierarchy/getLimitsById?SiteId=${siteId}&Id=${Id}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}

export async function postParamsData(Data, Id) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'POST',
    url: `/api/rubusMaster/hierarchy/updateLimits?SiteId=${siteId}&Id=${Id}`,
    headers: {
      Authorization: Authorization
    },
    data: Data
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => message.error(err.response.data.message));
}
